import { Stack } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";

export default function StatusFlagLayout() {
  return (
    <PageLayout
      screenName="Status Flags"
      titleClassName="text-primary-800"
      headerClassName="mx-dashboard"
      className="py-dashboard"
    >
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: "white" },
        }}
      />
    </PageLayout>
  );
}
